/**
 * Global Plugin JS
 */
const $ = jQuery;

class CredaiPlugin {
  constructor() {
    this.conversionLinks();
  }

  conversionLinks() {
    const android = /Android/i.test(navigator.userAgent);
    const iOS = navigator.platform.match(/iPhone|iPod|iPad/);

    // Google Play
    const $googlePlay = $(`#mobileHeaderGooglePlay`);
    if ($googlePlay.length) {
      const href = android ? "market://details?id=io.cred.roboapp.android" : "https://play.google.com/store/apps/details?id=io.cred.roboapp.android&hl=en_US";
      $googlePlay.attr(`href`, href);
    }

    // App Store
    const $appStore = $(`#mobileHeaderAppStore`);
    if ($appStore.length) {
      const href = iOS ? "itms-apps://apps.apple.com/us/app/cred-ai/id1393703565" : "https://apps.apple.com/us/app/cred-ai/id1393703565";
      $appStore.attr(`href`, href);
    }
  }
}

new CredaiPlugin();
